import { createSelector } from 'reselect';
import flatMap from 'lodash/flatMap';
import keys from 'lodash/keys';
import { getAvailableRoomTypes } from './getAvailableRoomTypes';

const getAllOffers = createSelector(getAvailableRoomTypes, (roomTypes) => flatMap(roomTypes, 'offers'));

export const getOfferIdsByFilter = createSelector(getAllOffers, (allOffers) => {
  const result = {
    all: [],
  };

  for (const offer of allOffers) {
    const filterKeys = keys(offer.meta);

    for (const key of filterKeys) {
      result[key] = result[key] || [];

      if (offer.meta[key]) {
        result[key].push(offer.id);
      }
    }

    result.all.push(offer.id);
  }

  return result;
});
